import { EventsActionSort } from './eventsActionSort';
import { EventsActionFilters } from './eventsActionFilters';
import { EventsActionColumns } from './eventsActionColumns';
import { DisplayText } from './displayText';
import { EventColumn } from './eventsColumn';
import { EventsActionFilter } from './eventsActionFilter';
import { EventsRefreshAction } from './eventsRefreshAction';

export class EventsAction {
    columns: EventsActionColumns;
    sort: EventsActionSort;
    group: DisplayText;
    filter: EventsActionFilter;
    customFilter?: EventsActionFilter;
    dataRefresh: EventsRefreshAction;

    constructor() {
        this.columns = new EventsActionColumns();
        this.sort = new EventsActionSort();
        this.group = null;
        this.filter = new EventsActionFilter();
        this.customFilter = new EventsActionFilter();
    }

    setFullColumnList(value: EventColumn[]) {
        this.columns.fullColumnList = value;
    }

    setDisplayedColumnList(value: EventColumn[]) {
        this.columns.displayedColumnList = value;
    }
}
